(function () {
  const initDesktopMegaSubmenu = (header) => {
    const megaSubmenuLinks = header.querySelectorAll(
      ".header-inline-menu__item--megasubmenu"
    );
    if (!megaSubmenuLinks || !megaSubmenuLinks.length) return;

    megaSubmenuLinks.forEach((link) => {
      const megaSubmenuEl = link.querySelector(".mega-submenu");
      if (!megaSubmenuEl) return;

      const hasSvgPlaceholder = megaSubmenuEl.querySelector(".placeholder-svg");

      if (hasSvgPlaceholder) {
        // Fixed an issue where placeholders in sections were not displayed because similar SVGs were in the mega menu with visibility hidden.
        document
          .querySelectorAll("svg.placeholder-svg g[clip-path]")
          .forEach((el) => {
            el.removeAttribute("clip-path");
          });
      }

      megaSubmenuEl.classList.add("mega-submenu--initialized");
    });

    const headerEl = header.querySelector(".header-inner");
    if (!headerEl) return;

    const viewportEdgeMargin = 16;

    const calcMegaSubmenuPosition = () => {
      const headerRect = headerEl.getBoundingClientRect();

      megaSubmenuLinks.forEach((link) => {
        const megaSubmenuEl = link.querySelector(".mega-submenu");
        if (!megaSubmenuEl) return;

        const linkMenuRect = link.getBoundingClientRect();
        const megaSubmenuRect = megaSubmenuEl.getBoundingClientRect();

        link?.addEventListener("mouseleave", () => {
          const focusElement = document.activeElement;
          if (link.contains(focusElement)) {
            focusElement.blur();
          }
        });

        const extraHeight = Math.abs(linkMenuRect.bottom - megaSubmenuRect.top);
        const extraHeightFix = Math.ceil(extraHeight);

        const submenuWidth = megaSubmenuRect.width;
        const naturalLeftViewport = linkMenuRect.left;
        const maxLeftViewport =
          window.innerWidth - submenuWidth - viewportEdgeMargin;
        const clampedLeftViewport = Math.max(
          viewportEdgeMargin,
          Math.min(naturalLeftViewport, maxLeftViewport)
        );
        const menuLeft = Math.round(clampedLeftViewport - headerRect.left);

        const bridgeLeftViewport =
          Math.min(linkMenuRect.left, clampedLeftViewport) - 8;
        const bridgeRightViewport =
          Math.max(linkMenuRect.right, clampedLeftViewport + submenuWidth) + 8;
        const extraLeft = Math.round(bridgeLeftViewport - clampedLeftViewport);
        const extraWidth = Math.ceil(bridgeRightViewport - bridgeLeftViewport);

        megaSubmenuEl.style.setProperty(
          "--extra-height",
          `${extraHeightFix}px`
        );
        megaSubmenuEl.style.setProperty("--mega-submenu-left", `${menuLeft}px`);
        megaSubmenuEl.style.setProperty("--extra-left", `${extraLeft}px`);
        megaSubmenuEl.style.setProperty("--extra-width", `${extraWidth}px`);
      });
    };

    const observer = new ResizeObserver((entries) => {
      entries.forEach((entry) => {
        calcMegaSubmenuPosition();
      });
    });

    observer.observe(headerEl);

    // The header-inner's own size never changes as its children animate in on load
    // (the load animation only uses transform/opacity), so the ResizeObserver above
    // never re-fires to correct a position calculated while items were still mid-animation.
    headerEl.addEventListener("animationend", (event) => {
      if (event.animationName !== "header-load-slide-up") return;
      calcMegaSubmenuPosition();
    });

    megaSubmenuLinks.forEach((link) => {
      link.addEventListener("mouseenter", calcMegaSubmenuPosition);
      link.addEventListener("focusin", calcMegaSubmenuPosition);
    });
  };

  const initMobileMegaSubmenu = (header) => {
    const megaSubmenuLinks = header.querySelectorAll(
      "header-mobile-drawer .header-mobile-menu__item--megasubmenu"
    );
    if (!megaSubmenuLinks || !megaSubmenuLinks.length) return;

    const openMobileMegaSubmenu = (megaSubmenuEl) => {
      if (
        !megaSubmenuEl ||
        !megaSubmenuEl.classList.contains("mega-submenu-mobile")
      ) {
        return;
      }

      megaSubmenuEl.classList.add("mega-submenu-mobile--visible");
      trapFocus(megaSubmenuEl.querySelector(".mega-submenu-mobile__wrapper"));
    };

    const closeMobileMegaSubmenu = (megaSubmenuEl, parentLink) => {
      if (
        !megaSubmenuEl ||
        !megaSubmenuEl.classList.contains("mega-submenu-mobile")
      ) {
        return;
      }

      megaSubmenuEl.classList.remove("mega-submenu-mobile--visible");
      removeTrapFocus(parentLink);
    };

    megaSubmenuLinks.forEach((item) => {
      const linkEl = item.querySelector(".header-mobile-menu__link");
      const megaSubmenuEl = item.querySelector(".mega-submenu-mobile");
      if (!linkEl || !megaSubmenuEl) return;

      const closeButton = megaSubmenuEl.querySelector(
        ".js-mega-submenu-mobile-close-trigger"
      );

      linkEl.addEventListener("click", (event) => {
        event.preventDefault();
        openMobileMegaSubmenu(megaSubmenuEl);
      });

      closeButton.addEventListener("click", (event) => {
        event.preventDefault();
        closeMobileMegaSubmenu(megaSubmenuEl, linkEl);
      });

      megaSubmenuEl.classList.add("mega-submenu-mobile--initialized");
    });
  };

  const initDesktopSubmenu = (header) => {
    const headerBox = header.querySelector(".header-inner");
    if (!headerBox) return;

    const submenuItems = headerBox.querySelectorAll(
      ".header-inline-menu__item--submenu"
    );
    if (!submenuItems || !submenuItems.length) return;

    const viewportEdgeMargin = 16;

    const calcSubmenuPosition = () => {
      const headerRect = headerBox.getBoundingClientRect();

      submenuItems.forEach((itemEl) => {
        const submenuEl = itemEl.querySelector(".header-inline-submenu");
        if (!submenuEl) return;

        const itemRect = itemEl.getBoundingClientRect();

        const delta = headerRect.bottom - itemRect.bottom + 10;
        submenuEl.style.top = `calc(100% + ${delta}px)`;

        submenuEl.style.removeProperty("--submenu-left");
        const submenuRect = submenuEl.getBoundingClientRect();
        const submenuWidth = submenuRect.width;
        const naturalLeftViewport = submenuRect.left;
        const maxLeftViewport =
          window.innerWidth - submenuWidth - viewportEdgeMargin;
        const clampedLeftViewport = Math.max(
          viewportEdgeMargin,
          Math.min(naturalLeftViewport, maxLeftViewport)
        );
        const submenuLeft = Math.round(clampedLeftViewport - itemRect.left);

        const extraHeight = Math.abs(itemRect.bottom - submenuRect.top);
        const extraHeightFix = Math.ceil(extraHeight);

        const bridgeLeftViewport =
          Math.min(itemRect.left, clampedLeftViewport) - 8;
        const bridgeRightViewport =
          Math.max(itemRect.right, clampedLeftViewport + submenuWidth) + 8;
        const extraLeft = Math.round(bridgeLeftViewport - clampedLeftViewport);
        const extraWidth = Math.ceil(bridgeRightViewport - bridgeLeftViewport);

        submenuEl.style.setProperty("--submenu-left", `${submenuLeft}px`);
        submenuEl.style.setProperty("--extra-height", `${extraHeightFix}px`);
        submenuEl.style.setProperty("--extra-left", `${extraLeft}px`);
        submenuEl.style.setProperty("--extra-width", `${extraWidth}px`);
      });
    };

    const observer = new ResizeObserver((entries) => {
      entries.forEach((entry) => {
        calcSubmenuPosition();
      });
    });

    observer.observe(headerBox);

    // The header-inner's own size never changes as its children animate in on load
    // (the load animation only uses transform/opacity), so the ResizeObserver above
    // never re-fires to correct a position calculated while items were still mid-animation.
    headerBox.addEventListener("animationend", (event) => {
      if (event.animationName !== "header-load-slide-up") return;
      calcSubmenuPosition();
    });

    submenuItems.forEach((itemEl) => {
      itemEl.addEventListener("mouseenter", calcSubmenuPosition);
      itemEl.addEventListener("focusin", calcSubmenuPosition);

      itemEl.addEventListener("mouseleave", () => {
        const focusElement = document.activeElement;
        if (itemEl.contains(focusElement)) {
          focusElement.blur();
        }
      });
    });
  };

  const initDesktopTabsSubmenu = (header) => {
    const headerBox = header.querySelector(".header-inner");
    if (!headerBox) return;

    const tabsSubmenuItems = headerBox.querySelectorAll(
      ".header-inline-menu__item--tabssubmenu"
    );
    if (!tabsSubmenuItems || !tabsSubmenuItems.length) return;

    const viewportEdgeMargin = 16;

    const calcTabsSubmenuPosition = () => {
      const headerRect = headerBox.getBoundingClientRect();

      tabsSubmenuItems.forEach((itemEl) => {
        const submenuEl = itemEl.querySelector(".tabs-submenu");
        if (!submenuEl) return;

        const itemRect = itemEl.getBoundingClientRect();

        const delta = headerRect.bottom - itemRect.bottom + 10;
        submenuEl.style.top = `calc(100% + ${delta}px)`;

        submenuEl.style.removeProperty("--tabs-submenu-left");
        const submenuRect = submenuEl.getBoundingClientRect();
        const submenuWidth = submenuRect.width;
        const naturalLeftViewport = submenuRect.left;
        const maxLeftViewport =
          window.innerWidth - submenuWidth - viewportEdgeMargin;
        const clampedLeftViewport = Math.max(
          viewportEdgeMargin,
          Math.min(naturalLeftViewport, maxLeftViewport)
        );
        const submenuLeft = Math.round(clampedLeftViewport - itemRect.left);

        const extraHeight = Math.abs(itemRect.bottom - submenuRect.top);
        const extraHeightFix = Math.ceil(extraHeight);

        const bridgeLeftViewport =
          Math.min(itemRect.left, clampedLeftViewport) - 8;
        const bridgeRightViewport =
          Math.max(itemRect.right, clampedLeftViewport + submenuWidth) + 8;
        const extraLeft = Math.round(bridgeLeftViewport - clampedLeftViewport);
        const extraWidth = Math.ceil(bridgeRightViewport - bridgeLeftViewport);

        submenuEl.style.setProperty("--tabs-submenu-left", `${submenuLeft}px`);
        submenuEl.style.setProperty("--extra-height", `${extraHeightFix}px`);
        submenuEl.style.setProperty("--extra-left", `${extraLeft}px`);
        submenuEl.style.setProperty("--extra-width", `${extraWidth}px`);
      });
    };

    const observer = new ResizeObserver((entries) => {
      entries.forEach((entry) => {
        calcTabsSubmenuPosition();
      });
    });

    observer.observe(headerBox);

    // The header-inner's own size never changes as its children animate in on load
    // (the load animation only uses transform/opacity), so the ResizeObserver above
    // never re-fires to correct a position calculated while items were still mid-animation.
    headerBox.addEventListener("animationend", (event) => {
      if (event.animationName !== "header-load-slide-up") return;
      calcTabsSubmenuPosition();
    });

    tabsSubmenuItems.forEach((itemEl) => {
      const tabs = itemEl.querySelectorAll(".tabs-submenu__tab");
      const submenus = itemEl.querySelectorAll(".tabs-submenu__submenu");

      const onToggle = (event) => {
        const tab = event.target;
        if (!tab || !tab.classList.contains("tabs-submenu__tab")) return;
        const tabId = tab.dataset.tabId;

        tabs.forEach((tab) => {
          tab.classList.remove("active");
        });
        tab.classList.add("active");

        submenus.forEach((submenu) => {
          submenu.classList.remove("active");
          if (submenu.dataset.tabId === tabId) {
            submenu.classList.add("active");
          }
        });

        calcTabsSubmenuPosition();
      };

      tabs.forEach((tab) => {
        tab.addEventListener("click", onToggle);
        tab.addEventListener("mouseenter", onToggle);
      });

      itemEl.addEventListener("mouseenter", calcTabsSubmenuPosition);
      itemEl.addEventListener("focusin", calcTabsSubmenuPosition);

      itemEl.addEventListener("mouseleave", () => {
        const focusElement = document.activeElement;
        if (itemEl.contains(focusElement)) {
          focusElement.blur();
        }
      });
    });
  };

  const initBurgerMenu = (header) => {
    const burgerMenus = header.querySelectorAll("burger-menu");
    if (!burgerMenus || !burgerMenus.length) return;

    burgerMenus.forEach((burgerMenu) => {
      const tabs = burgerMenu.querySelectorAll(".burger-menu__tab");
      const panels = burgerMenu.querySelectorAll(".burger-menu__panel");
      const panelsEl = burgerMenu.querySelector(".burger-menu__panels");
      const footerEl = burgerMenu.querySelector(".burger-menu__footer");

      const updateOverflow = () => {
        if (!panelsEl) return;
        const hasOverflow = panelsEl.scrollHeight > panelsEl.clientHeight + 1;
        panelsEl.classList.toggle("has-overflow", hasOverflow);
      };

      const updateFooterHeight = () => {
        if (!footerEl) return;
        const footerHeight = footerEl.getBoundingClientRect().height;
        burgerMenu.style.setProperty(
          "--burger-menu-footer-height",
          `${footerHeight}px`
        );
        updateOverflow();
      };

      const activateTab = (tab) => {
        if (!tab) return;
        const tabId = tab.dataset.burgerTabId;

        tabs.forEach((otherTab) => {
          otherTab.classList.remove("active");
        });
        tab.classList.add("active");

        panels.forEach((panel) => {
          panel.classList.remove("active");
          if (panel.dataset.burgerTabId === tabId) {
            panel.classList.add("active");
          }
        });

        updateOverflow();
      };

      tabs.forEach((tab) => {
        tab.addEventListener("mouseenter", () => activateTab(tab));
        tab.addEventListener("click", () => activateTab(tab));
      });

      if (panelsEl) {
        const observer = new ResizeObserver(() => updateOverflow());
        observer.observe(panelsEl);
      }

      if (footerEl) {
        const footerObserver = new ResizeObserver(() => updateFooterHeight());
        footerObserver.observe(footerEl);
      }
    });

    const menuLinkTriggers = header.querySelectorAll(
      "[data-opens-burger-menu]"
    );
    const burgerMenuEl = burgerMenus[0];
    const detailsEl = burgerMenuEl.querySelector(".burger-menu-container");
    const openBtn = burgerMenuEl.querySelector(".js-burger-menu-open");

    if (menuLinkTriggers.length && detailsEl && openBtn) {
      // Wait for the burger-menu custom element to upgrade: clicking openBtn
      // before that only triggers the native <details> toggle, without the
      // menu-opening class the styles need to actually reveal the panel.
      customElements.whenDefined("burger-menu").then(() => {
        menuLinkTriggers.forEach((trigger) => {
          trigger.addEventListener("click", (event) => {
            event.preventDefault();
            if (detailsEl.hasAttribute("open")) return;
            openBtn.click();
          });
        });
      });
    }
  };

  const initHeaderOverlay = (header) => {
    const main = document.getElementById("MainContent");
    const sections = main.querySelectorAll(".shopify-section");
    const breadcrumbs = document.querySelector("#breadcrumbs");
    const hasOverlayMode = Boolean(
      header.querySelector(".header-wrapper--overlay-mode")
    );
    let isOverlayEnabled = false;

    const removeColorScheme = (element) => {
      if (!element) return;
      let classNames = element.getAttribute("class");
      classNames = classNames.replace(/color-background-\d+/g, "");
      element.setAttribute("class", classNames);
    };

    if (sections.length > 0 && hasOverlayMode) {
      const hasTargetSection =
        sections[0].classList.contains("has-header-overlay");
      const sectionTargetChild = sections[0].querySelector(
        "[data-header-overlay]"
      );
      const headerGroupSections = document.querySelectorAll(
        ".shopify-section-group-header-group"
      );

      if (hasTargetSection && sectionTargetChild) {
        if (headerGroupSections[headerGroupSections.length - 1] === header) {
          isOverlayEnabled = true;
          sections[0].classList.remove("not-margin");
          header.classList.remove("not-mode");
          if (breadcrumbs) {
            removeColorScheme(breadcrumbs);
            const colorScheme = sectionTargetChild.dataset.colorScheme;
            if (colorScheme) breadcrumbs.classList.add(`color-${colorScheme}`);
          }
        } else {
          isOverlayEnabled = false;
          sections[0].classList.add("not-margin");
          header.classList.add("not-mode");
          if (breadcrumbs) removeColorScheme(breadcrumbs);
        }
      } else {
        isOverlayEnabled = false;
        header.classList.add("not-mode");
        if (breadcrumbs) removeColorScheme(breadcrumbs);
      }
    } else {
      isOverlayEnabled = false;
      header.classList.add("not-mode");
      if (breadcrumbs) removeColorScheme(breadcrumbs);
    }

    const controlHoveredState = () => {
      const headerWrapper = header.querySelector(".header-wrapper");
      if (!headerWrapper) return;

      const triggeredItems = headerWrapper.querySelectorAll(
        '.header-inline-menu__item[data-show-on-hover="true"]'
      );

      let removeHoverTimeout = null;
      let removeAnimateTimeout = null;

      triggeredItems.forEach((triggeredItem) => {
        triggeredItem.addEventListener("mouseenter", () => {
          clearTimeout(removeHoverTimeout);
          clearTimeout(removeAnimateTimeout);

          headerWrapper.classList.add("header-hover-triggered");
          headerWrapper.classList.add("header-hover-animate");
        });

        triggeredItem.addEventListener("mouseleave", () => {
          removeHoverTimeout = setTimeout(() => {
            const isStillHovered = Array.from(triggeredItems).some((el) =>
              el.matches(":hover")
            );

            if (!isStillHovered) {
              headerWrapper.classList.remove("header-hover-triggered");

              removeAnimateTimeout = setTimeout(() => {
                headerWrapper.classList.remove("header-hover-animate");
              }, 300);
            }
          }, 0);
        });
      });
    };

    if (isOverlayEnabled) {
      controlHoveredState();
    }
  };

  const initHeader = () => {
    const header = document.querySelector(".shopify-section-header");
    if (!header) return;

    initHeaderOverlay(header);
    initDesktopMegaSubmenu(header);
    initMobileMegaSubmenu(header);
    initDesktopSubmenu(header);
    initDesktopTabsSubmenu(header);
    initBurgerMenu(header);
  };

  initHeader();

  document.addEventListener("shopify:section:load", initHeader);
  document.addEventListener("shopify:section:unload", initHeader);
  document.addEventListener("shopify:section:reorder", initHeader);
})();

if (!customElements.get("header-search")) {
  customElements.define(
    "header-search",
    class HeaderSearch extends HTMLElement {
      constructor() {
        super();

        this.open = this.onOpen.bind(this);
        this.close = this.onClose.bind(this);
        this.onKeyDownBody = this.onKeydownBody.bind(this);
        this.onKeyDownOption = this.onKeydownOption.bind(this);
        this.onKeyUpOption = this.onKeyupOption.bind(this);
      }

      connectedCallback() {
        this.header = document.querySelector(".header-wrapper");
        this.openBtn = this.querySelector(".js-search-modal-trigger");
        this.modalEl = document.querySelector(".header-search-modal");
        if (!this.modalEl) return;

        this.closeBtn = this.modalEl.querySelector(".js-search-close-trigger");
        this.input = this.modalEl.querySelector("#Search-In-Modal");
        this.overlayEl = this.modalEl.querySelector(
          ".header-search-modal__overlay"
        );
        this.menuEl = this.modalEl.querySelector(".header-search-modal__menu");
        this.predictiveSearchEl =
          this.modalEl.querySelector("predictive-search");

        this.isMac = this.identifyDevice();

        this.openBtn?.addEventListener("click", this.open);
        this.closeBtn?.addEventListener("click", this.close);
        this.overlayEl?.addEventListener("click", this.close);

        document.body.addEventListener("keydown", this.onKeyDownBody);
        this.modalEl.addEventListener("keydown", this.onKeyDownOption);
        this.modalEl.addEventListener("keyup", this.onKeyUpOption);
      }

      disconnectedCallback() {
        document.body.removeEventListener("keydown", this.onKeyDownBody);
      }

      onOpen(event) {
        if (event) event.preventDefault();
        if (this.header) this.header.preventHide = true;
        this.isOpen = true;
        this.modalEl.setAttribute("open", true);
        if (this.openBtn) this.openBtn.setAttribute("aria-expanded", "true");

        this.modalEl.addEventListener(
          "transitionend",
          () => {
            if (this.isOpen) {
              trapFocus(this.modalEl);
            }
          },
          { once: true }
        );

        // using setTimeout makes the modal window appear more smoothly
        this._focusTimeout = setTimeout(() => {
          if (this.input) this.input.focus();
        }, 400);

        document.body.classList.add("overflow-hidden-search-open");

        // styles for forced disable body scroll on iOS
        if (typeof window.lockScrollBodyOnIos === "function") {
          this.openScrollY = window.scrollY;
          window.lockScrollBodyOnIos(this.openScrollY);
        }
      }

      onClose(event, elementToFocus = null) {
        if (event) event.preventDefault();
        if (!this.isOpen) return;
        clearTimeout(this._focusTimeout);
        this.isOpen = false;
        this.modalEl.removeAttribute("open");
        if (this.openBtn) this.openBtn.setAttribute("aria-expanded", "false");
        if (this.header) this.header.preventHide = false;

        document.body.classList.remove("overflow-hidden-search-open");

        if (this.input) {
          this.input.setAttribute("aria-activedescendant", "");
        }

        const newFocusElement = elementToFocus ? elementToFocus : this.openBtn;
        removeTrapFocus(newFocusElement);

        // styles for forced disable body scroll on iOS
        if (typeof window.unlockScrollBodyOnIos === "function") {
          window.unlockScrollBodyOnIos(this.openScrollY);
        }
      }

      onKeyupOption(event) {
        const isOpen = this.modalEl.getAttribute("open");
        if (!isOpen || !(this.menuEl || this.predictiveSearchEl)) return;
        if (event.code === "Enter") {
          const target = event.target;

          if (target.tagName.toLowerCase() === "button") {
            return;
          }

          event.preventDefault();
          this.selectOption();
        }
      }

      onKeydownOption(event) {
        const isOpen = this.modalEl.getAttribute("open");
        if (!isOpen || !(this.menuEl || this.predictiveSearchEl)) return;

        if (event.code === "ArrowUp" || event.code === "ArrowDown") {
          const targetTag = event.target.tagName.toLowerCase();
          if (
            targetTag !== "input" &&
            targetTag !== "a" &&
            targetTag !== "div"
          ) {
            return;
          }

          event.preventDefault();
          event.stopImmediatePropagation();
          this.switchOption(event.code === "ArrowUp" ? "up" : "down");
        }
      }

      onKeydownBody(event) {
        const isOpen = this.modalEl.getAttribute("open");

        if (isOpen && event.key === "Escape") {
          this.close();
          return;
        }

        if (!isOpen) {
          const key = event?.key?.toLowerCase();
          const isMac = this.isMac;
          const isCmdK = isMac && event?.metaKey && key === "k";
          const isCtrlK = !isMac && event?.ctrlKey && key === "k";

          if (isCmdK || isCtrlK) {
            event.preventDefault();
            this.open();
          }
        }
      }

      switchOption(direction) {
        if (!this.modalEl.getAttribute("open")) return;

        const moveUp = direction === "up";
        const selectedElement = this.modalEl.querySelector(
          '[aria-selected="true"]'
        );

        const allVisibleElements = Array.from(
          this.modalEl.querySelectorAll("[role='option']")
        ).filter((element) => element.offsetParent !== null);

        if (allVisibleElements.length === 0) return;

        let selectedElementIndex = allVisibleElements.indexOf(selectedElement);
        let activeElementIndex = 0;

        if (selectedElementIndex === -1) {
          activeElementIndex = moveUp ? allVisibleElements.length - 1 : 0;
        } else {
          if (moveUp) {
            activeElementIndex =
              selectedElementIndex === 0
                ? allVisibleElements.length - 1
                : selectedElementIndex - 1;
          } else {
            activeElementIndex =
              selectedElementIndex === allVisibleElements.length - 1
                ? 0
                : selectedElementIndex + 1;
          }
        }

        if (this.predictiveSearchEl && this.predictiveSearchEl.statusElement) {
          this.predictiveSearchEl.statusElement.textContent = "";
        }

        const activeElement = allVisibleElements[activeElementIndex];
        if (!activeElement) return;

        activeElement.setAttribute("aria-selected", true);
        if (selectedElement) {
          selectedElement.setAttribute("aria-selected", false);
        }

        if (this.input) {
          this.input.setAttribute("aria-activedescendant", activeElement.id);
        }

        activeElement.scrollIntoView({
          block: "nearest",
          inline: "nearest",
          behavior: "smooth",
        });
      }

      selectOption() {
        const selectedOption = this.modalEl.querySelector(
          '[aria-selected="true"] a'
        );
        if (selectedOption) selectedOption.click();
      }

      identifyDevice() {
        const isMac =
          /Mac/.test(navigator.platform) ||
          navigator.userAgentData?.platform?.toLowerCase() === "macos" ||
          navigator.userAgentData?.platform?.toLowerCase().includes("mac");

        return isMac;
      }
    }
  );
}
